const LOCAL_STORAGE = {
  accessToken: 'auth0AccessToken',
  tokenExpiresAt: 'auth0TokenExpiresAt',
};

export default LOCAL_STORAGE;
